import { render } from "./EmployeeDataImportModal.vue?vue&type=template&id=52ae849f&scoped=true"
import script from "./EmployeeDataImportModal.vue?vue&type=script&lang=js"
export * from "./EmployeeDataImportModal.vue?vue&type=script&lang=js"

import "./EmployeeDataImportModal.vue?vue&type=style&index=0&id=52ae849f&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ae849f"]])

export default __exports__